import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const GroupsListTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('groups.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('groups.fields.name') + ': ' },
    { variable: 'description', text: t('groups.fields.description') + ': ' },
    { variable: 'module', text: t('groups.fields.module') + ': ' },
    {
      variable: 'active',
      text: t('groups.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.custom_group.update',
    togglePermission: 'acl.custom_group.toggle',
    editUrl: 'groups', //Url para editar empleado
    propsName: 'group', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };
  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('groups.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('groups.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="description"
            handleOrderChange={handleOrderChange}
          >
            {t('groups.fields.description')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="module"
            handleOrderChange={handleOrderChange}
          >
            {t('groups.fields.module')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('groups.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(GroupsListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/GroupsListTable.js